function SkillsTechno() {
  return (
    <div className="divAllTechno">
      <div className="divContainerTechno" style={{ "--i": 1 }}>
        <div className="divSpan">
          <span>JAVASCRIPT</span>
          <span>TYPESCRIPT</span>
          <span>TAILWINDCSS</span>
        </div>
      </div>
      <div className="divContainerTechno" style={{ "--i": 2 }}>
        <div className="divSpan">
          <span>REACT.JS</span>
          <span>NEXTJS</span>
          <span>NODE.JS</span>
        </div>
      </div>
      <div className="divContainerTechno" style={{ "--i": 3 }}>
        <div className="divSpan">
          <span>SEO</span>
          <span>WORDPRESS</span>
          <span>MONGODB</span>
        </div>
      </div>
    </div>
  );
}

export default SkillsTechno;
